<template>
  <div>

    <!-- Message box -->
    <div
        v-if="message"
        :class="messageType"
        class="mt-24 fixed top-5 left-1/2 transform -translate-x-1/2 p-4 rounded-lg text-center shadow-lg text-black dark:bg-dark-box-bg dark:text-dark-text dark:border dark:border-dark-border transition-all duration-500"
        style="width: 90%; max-width: 1200px; z-index: 3000;"
    >

    {{ message }}
      <div
          class="z-5000 absolute bottom-0 left-0 h-1"
          :style="{ width: progress + '%', backgroundColor: getProgressColor(), borderRadius: '8px' }"
      ></div>
    </div>

    <!-- Przycisk dzwonka z liczbą powiadomień -->
    <div v-if="isAuthenticated && authStore.user.role != 'ROLE_DRIVER'" class="fixed top-8 right-10 z-2000">
      <button
          @click="toggleNotifications"
          ref="notificationButton"
          class="bg-button-bg text-button-text p-4 rounded-full shadow-lg focus:outline-none hover:bg-button-hover relative transition-all duration-200 ease-in-out transform hover:scale-110 active:scale-95 dark:bg-dark-button-bg dark:hover:bg-dark-button-hover z-20"
      >
        <BellIcon
            class="h-6 w-6 transition-transform duration-200 ease-in-out transform"
            :class="{ 'animate-bell': isBellRinging }"
            @mouseover="isBellRinging = true"
            @mouseleave="isBellRinging = false"
        />
        <span
            v-if="unreadNotifications && unreadNotifications.length"
            class="absolute top-0 right-0 bg-light-status-unavailable dark:bg-dark-status-unavailable text-white text-xs rounded-full w-5 h-5 flex items-center justify-center"
        >
          {{ unreadNotifications.length }}
        </span>
      </button>
    </div>

    <!-- Przycisk ostrzeżeń -->
     <!-- Tutaj było right-24 zmieniłem na right-10 -->
    <!-- <div v-if="isAuthenticated && authStore.user.role == 'ROLE_DRIVER'" class="fixed bottom-8 right-8 z-2000">
      <button
          @click="fetchWarnings()"
          ref="warningButton"
          class="mx-4 bg-red-500 text-white p-4 rounded-full shadow-lg focus:outline-none hover:bg-red-600 relative transition-all duration-200 ease-in-out transform hover:scale-110 active:scale-95"
      >
        <ExclamationTriangleIcon
            class="h-6 w-6 transition-transform duration-200 ease-in-out transform"
        />
        <span
            v-if="warnings && warnings.length"
            class="absolute top-0 right-0 bg-red-700 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center"
        >
          {{ warnings.length }}
        </span>
      </button>
    </div> -->

    <!-- Widget z powiadomieniami -->
    <transition name="slide-fade">
      <div
          v-if="isAuthenticated && showNotifications && (notifications.length || noNotificationsMessage) && authStore.user.role != 'ROLE_DRIVER'"
          class="fixed top-32 right-10 w-full max-w-xs sm:max-w-xs md:max-w-md lg:max-w-lg bg-light-bg dark:bg-dark-bg p-4 rounded-lg shadow-custom-light dark:shadow-custom-dark border border-light-border dark:border-dark-border"
          ref="notificationWidget"
      >
        <div class="flex items-center justify-between border-b border-light-border dark:border-dark-border pb-3 mb-4">
          <h3 class="text-xl font-semibold text-light-text dark:text-dark-text">Powiadomienia</h3>

          <!-- Kontener z responsywnym układem -->
          <div class="flex items-center space-x-2">
            <button
                @click="deleteAllNotifications"
                :disabled="noNotificationsMessage"
                class="text-sm sm:text-base px-2 sm:px-4 py-1 sm:py-2 text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-500 focus:outline-none transition-all z-20"
            >
              Usuń wszystkie
            </button>

            <button
                @click="closeWidget"
                class="text-light-text hover:text-gray-700 dark:text-dark-text dark:hover:text-white focus:outline-none transition-all"
            >
              <span class="text-lg sm:text-xl">&times;</span>
            </button>
          </div>
        </div>

        <!-- Jeśli brak powiadomień, wyświetl komunikat -->
        <p v-if="noNotificationsMessage" class="text-center text-gray-500 dark:text-gray-300">
          Brak powiadomień
        </p>

        <!-- Lista powiadomień -->
        <ul v-if="notifications.length" class="space-y-4 max-h-[400px] overflow-y-auto overflow-x-hidden">
          <li
              v-for="notification in notifications"
              :key="notification.id"
              class="p-4 bg-light-row-even dark:bg-dark-row-even rounded-md shadow flex items-center justify-between hover:scale-105 transition-transform duration-200 ease-in-out"
          >
            <span class="mr-4 text-teal-700 whitespace-nowrap">{{ formatDate(notification.notification.executionDate) }}</span>
            <p class="flex-grow mx-4 text-light-text dark:text-dark-text">{{ notification.notification.message }}</p>
            <button
                @click="removeNotification(notification.notification.id)"
                class="ml-4 text-light-status-unavailable hover:text-red-700 dark:text-dark-status-unavailable dark:hover:text-red-600 focus:outline-none"
            >
              &times;
            </button>
          </li>
        </ul>
      </div>
    </transition>

    <!-- Widget z ostrzeżeniami -->
    <transition name="slide-fade">
      <div
          v-if="isAuthenticated && showWarnings && warnings.length"
          class="fixed top-32 right-24 w-full max-w-xs sm:max-w-xs md:max-w-md lg:max-w-lg bg-red-100 dark:bg-red-900 p-4 rounded-lg shadow-custom-light dark:shadow-custom-dark border border-red-400 dark:border-red-700"
          ref="warningWidget"
      >
        <div class="flex items-center justify-between border-b border-red-400 dark:border-red-700 pb-3 mb-4">
          <h3 class="text-xl font-semibold text-red-700 dark:text-red-400">Ostrzeżenia</h3>
          <button @click="closeWarningWidget" class="text-red-700 hover:text-red-500 dark:text-red-400 dark:hover:text-red-300 focus:outline-none">
            <span class="text-lg">&times;</span>
          </button>
        </div>
        <ul class="space-y-4 max-h-[400px] overflow-y-auto overflow-x-hidden">
          <li
              v-for="warning in warnings"
              :key="warning.id"
              class="p-4 bg-red-200 dark:bg-red-800 rounded-md shadow flex items-center justify-between hover:scale-105 transition-transform duration-200 ease-in-out"
          >
            <span class="mr-4 text-red-700 whitespace-nowrap">{{ formatDate(warning.date) }}</span>
            <p class="flex-grow mx-4 text-red-800 dark:text-red-200">{{ warning.message }}</p>
            <button
                @click="removeWarning(warning.id)"
                class="ml-4 text-red-600 hover:text-red-500 dark:text-red-400 dark:hover:text-red-300 focus:outline-none"
            >
              &times;
            </button>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>


<script>
import notificationService from '@/services/notificationService';
import { useAuthStore } from '@/stores/authStore';
import { useSessionStore } from '@/stores/useSessionStore';
import { BellIcon } from '@heroicons/vue/24/solid';
import { computed, watch } from 'vue';

export default {
  components: {
    BellIcon,
  },
  setup() {
    const authStore = useAuthStore();
    if (authStore.isAuthenticated) {
        authStore.checkExpiration();
    }
    const user = computed(() => authStore.user);
    const isAuthenticated = computed(() => authStore.isAuthenticated);
    const sessionStore = useSessionStore();

    // Watcher, który reaguje na zmianę użytkownika
    watch(user, (newUser) => {
      if (newUser && newUser.uid) {
        // Teraz możemy korzystać z newUser.uid
        // console.log('Użytkownik jest załogowany:', newUser.uid);
      } else {
        // console.log('Brak użytkownika');
      }
    }, { immediate: true });
    return { user, isAuthenticated, authStore, sessionStore };
  },
  data() {
    return {
      notifications: [],
      noNotificationsMessage: false,
      showNotifications: false,
      isBellRinging: false,

      warnings: [],
      showWarnings: false,

      // Message box state
      message: '',
      messageType: '',
      progress: 0,
    };
  },
  computed: {
    unreadNotifications() {
      return Array.isArray(this.notifications)
      ? this.notifications.filter(notification => !notification.read)
      : [];
    }
  },
  methods: {
    async deleteAllNotifications() {
      try {
        // Wywołanie metody serwisowej, która usuwa wszystkie powiadomienia na backendzie
        await notificationService.deleteAllNotifications(this.user.uid);
        
        // Zaktualizowanie lokalnej listy powiadomień, usuwając wszystkie powiadomienia
        this.notifications = [];
        
        // Opcjonalnie, możesz wyświetlić komunikat o sukcesie
        this.showMessage('Wszystkie powiadomienia zostały usunięte.', 'success');
      } catch (error) {
        // Obsługa błędu, np. wyświetlenie komunikatu
        console.error('Błąd podczas usuwania powiadomień:', error);
        this.showMessage('Wystąpił błąd podczas usuwania powiadomień.', 'error');
      }
    },
    async fetchNotifications() {
      try {
        const response = await notificationService.getNotifications(this.user.uid);
        this.notifications = response.data;

        this.noNotificationsMessage = this.notifications.length === 0;
      } catch (error) {
        console.error('Błąd podczas pobierania powiadomień:', error);
      }
    },
    toggleNotifications() {
      this.showNotifications = !this.showNotifications;
      if (this.showNotifications) {
        this.fetchNotifications();
        // this.markAllAsRead();
      }
    },

    // WEŹ SE TO ZOBACZ TYM MŁODYM
    // Pobieranie ostrzeżeń
    async fetchWarnings() {
      await notificationService.reportBreakdown(this.user.uid);
      this.showMessage("Awaria została zgłoszona pomyślnie.", "success");
      await this.authStore.fetchDriverData(this.user.uid);
    },

    showMessage(msg, type) {
      this.message = msg;
      this.messageType = type === "success" ? "bg-green-500 text-white" : "bg-red-500 text-white";
      this.progress = 0;

      const interval = 30; // Odświeżanie progresu
      const duration = 5000; // Czas wyświetlania (3 sekundy)
      const step = 100 / (duration / interval);

      const progressInterval = setInterval(() => {
        this.progress += step;
        if (this.progress >= 100) {
          clearInterval(progressInterval);
          this.progress = 0;
          this.message = '';
          this.messageType = '';
          this.clearMessage();
        }
      }, interval);
    },
    clearMessage() {
      this.message = '';
      this.messageType = '';
      this.progress = 0;
    },
    getProgressColor() {
      return this.messageType === "bg-green-500 text-white" ? "#16a34a" : "#b91c1c";
    },

    // Przełączanie widgetu ostrzeżeń
    toggleWarnings() {
      this.showWarnings = !this.showWarnings;
      this.showNotifications = false; // Ukryj widget powiadomień
      if (this.showWarnings) {
        this.fetchWarnings();
      }
    },
    // Zamknięcie widgetu ostrzeżeń
    closeWarningWidget() {
      this.showWarnings = false;
    },
    async removeWarning(id) {
      try {
        this.warnings = this.warnings.filter((warning) => warning.id !== id);
      } catch (error) {
        console.error('Błąd podczas usuwania ostrzeżenia:', error);
      }
    },
    closeWidget() {
      this.showNotifications = false;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async markAllAsRead() {
        try {
            // Prześlij żądanie do backendu, aby oznaczyć wszystkie powiadomienia jako przeczytane
            await notificationService.markAllAsRead();
            // Zaktualizuj lokalną listę powiadomień
            this.notifications.forEach(notification => {
                notification.read = true;
            });
        } catch (error) {
            console.error('Błąd podczas oznaczania wszystkich powiadomień jako przeczytane:', error);
        }
    },
    async removeNotification(id) {
      try {
        await notificationService.deleteNotificationForUser(id, this.user.uid);

        this.notifications = this.notifications.filter(notification => notification.notification.id !== id);
      } catch (error) {
        console.error('Błąd podczas oznaczania powiadomienia jako przeczytane:', error);
      }
    },
    handleClickOutside(event) {
      const widget = this.$refs.notificationWidget;
      const button = this.$refs.notificationButton;
      if (
          widget &&
          !widget.contains(event.target) &&
          button &&
          !button.contains(event.target) &&
          this.showNotifications
      ) {
        this.closeWidget();
      }
    },
    refreshNotifications() {
      // Użycie sessionStore do zarządzania interwałem
      this.sessionStore.startInterval(async () => {
        try {
          await this.fetchNotifications();
        } catch (error) {
          console.error('Błąd podczas odświeżania:', error);
        }
      }, 15000); // 15 sekund
    },
  },
  mounted() {
    if (this.isAuthenticated) {
      this.fetchNotifications();
      this.refreshNotifications();
    }
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    if (this.sessionStore.intervalId) {
      clearInterval(this.sessionStore.intervalId); // Oczyść interval, jeśli jest ustawiony
      this.sessionStore.intervalId = null; // Reset interval to prevent any issues if it tries to be cleared again
    }
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped>
/* Animacja dzwonka */
@keyframes bell {
  0% { transform: translateY(0); }
  25% { transform: translateY(-2px); }
  50% { transform: translateY(0); }
  75% { transform: translateY(6px); }
  100% { transform: translateY(0); }
}
.animate-bell {
  animation: bell 0.3s ease forwards;
}

/* Styl animacji wysuwania boxa */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-fade-enter-from {
  transform: translateY(-20px) scale(0.95);
  opacity: 0;
}
.slide-fade-enter-to {
  transform: translateY(0) scale(1);
  opacity: 1;
}
.slide-fade-leave-from {
  transform: translateY(0) scale(1);
  opacity: 1;
}
.slide-fade-leave-to {
  transform: translateY(-20px) scale(0.95);
  opacity: 0;
}

/* Styl paska przewijania dla dark i light mode */
.overflow-y-auto::-webkit-scrollbar {
  width: 8px;
}
.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #d1d5db; /* Jasnoszary kolor dla trybu light */
  border-radius: 8px;
  border: 2px solid #9ca3af;
}
.overflow-y-auto::-webkit-scrollbar-track {
  background-color: #f3f4f6;
  border-radius: 8px;
}

/* Pasek przewijania w trybie ciemnym */
.dark .overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #2c7a7a; /* Teal-700 */
  border-radius: 8px;
  border: 2px solid #1a5d5d; /* Ciemniejszy teal dla suwaka */
}
.dark .overflow-y-auto::-webkit-scrollbar-track {
  background-color: #333333;
  border-radius: 8px;
}
</style>
